export const MANDAT = 'https://www.immonline.fr/faq/mandat-gestion-locative'
export const FRAIS ='https://www.immonline.fr/faq/frais-gestion-locative'
export const ADMINISTRATEUR = 'https://www.immonline.fr/faq/administrateur-de-biens'

export const GESTION_LYON = 'https://www.immonline.fr/ville/gestion-locative-lyon'
export const GESTION_PARIS = 'https://www.immonline.fr/ville/gestion-locative-paris'

export const ATTESTATION_HEBERGEMENT = 'https://www.immonline.fr/fichiers/attestationdhebergement.pdf'
export const CHANGEMENT_ADRESSE = 'https://www.immonline.fr/fichiers/changementdadresse.pdf'
export const COURRIER_RESILIATION = 'https://www.immonline.fr/fichiers/courrier-resiliation-mandat-de-gestion.pdf'
export const COMPTE_RENDU_GERANCE = 'https://www.immonline.fr/fichiers/explication-compte-rendu-de-gerance-immo-online.pdf'
export const FORMALITE_DEMENAGEMENT = 'https://www.immonline.fr/fichiers/formalitespourdemenagement.pdf'
export const CONSOMMATION_EAU = 'https://www.immonline.fr/fichiers/la_consommation_d_eau.pdf'
export const DEGAT_EAU = 'https://www.immonline.fr/fichiers/le_degat_des_eaux.pdf'
export const TRI_DECHETS = 'https://www.immonline.fr/fichiers/le_tri_des_dechets_menagers.pdf'
export const BRUITS_VOISINAGE = 'https://www.immonline.fr/fichiers/les_bruits_du_voisinage.pdf'
export const CHARGES_LOCATIVES = 'https://www.immonline.fr/fichiers/les_charges_locatives.pdf'
export const REPARATIONS_LOCATIVES = 'https://www.immonline.fr/fichiers/les_reparations_locatives.pdf'
export const FAIRE_GERER = 'https://www.immonline.fr/fichiers/pourquoifairegerersonbienimmobilier.pdf'

export const HOME = 'https://www.immonline.fr/'
export const OFFRES = "https://www.immonline.fr/offres"
export const DEVIS = 'https://www.immonline.fr/demande-de-devis'
export const DEVENIR_PARTENAIRE = 'https://www.immonline.fr/partenaire'

export const COMPANY_LOCATION = 'https://www.google.com/maps/place/IMMO+ONLINE/@48.8855235,2.2975526,17z/data=!3m1!4b1!4m5!3m4!1s0x47e66f97a54860dd:0xb97f0dae82c71fa2!8m2!3d48.88552!4d2.2997466'
export const PHONE_NUMBER = "tel:0173790910"
export const EMAIL = 'mailto:gestion@immonline.fr'
export const CONTACT = 'https://www.immonline.fr/contact'